import useDotsLoader from "@/hooks/useDotsLoader.hook";
import styles from "./checkout-loader.module.scss";
import React from "react";
import { BiCheckCircle } from "react-icons/bi";
import Image from "next/image";
import LoadingIcon from "@public/animated-logo-cropped.gif";
import BlessButton from "@components/layout/button/green-outline-btn";
import { CheckoutStatusType } from "@/features/bridge/types/checkout.types";

interface Props {
  loadingStatus: CheckoutStatusType | null;
  buttonFunc?: () => void;
  buttonText: string;
}

const CheckoutLoader = ({ loadingStatus, buttonFunc, buttonText }: Props) => {
  const dots = useDotsLoader();

  const checkoutStatus = () => {
    switch (loadingStatus) {
      case CheckoutStatusType.CheckingOut:
        return "Bridging";
      case CheckoutStatusType.CheckingForApproval:
        return "Checking for approval";
      case CheckoutStatusType.CheckingForAllowance:
        return "Checking for allowance";
      case CheckoutStatusType.RequestingAllowance:
        return "Requesting allowance";
      case CheckoutStatusType.SettingApproval:
        return "Setting approval";
      case CheckoutStatusType.BridgingOut:
        return "Bridging";
      case CheckoutStatusType.Success:
        return "Bridging Success!";
    }
  };

  const checkoutStatusSubText = () => {
    switch (loadingStatus) {
      case CheckoutStatusType.Success:
        return "It may take up to thirty minutes for your assets to arrive on the destination chain";
      default:
        return null;
    }
  };

  if (!!loadingStatus)
    return (
      <div className={styles.container}>
        {loadingStatus === CheckoutStatusType.Success ? (
          <BiCheckCircle size={80} className={styles.successIcon} />
        ) : (
          <div className={styles.loadingIcon}>
            <Image src={LoadingIcon} alt="blessnet-loading" />
          </div>
        )}
        <p>
          {checkoutStatus()}
          {loadingStatus !== CheckoutStatusType.Success && <span>{dots}</span>}
        </p>
        {checkoutStatusSubText() && (
          <p className={styles.subText}>{checkoutStatusSubText()}</p>
        )}
        {loadingStatus === CheckoutStatusType.Success && (
          <BlessButton styles={{ marginTop: 20 }} onClick={buttonFunc}>
            {buttonText}
          </BlessButton>
        )}
      </div>
    );
};

export default CheckoutLoader;
